
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.836 1.422a1 1 0 00-1.414 1.414L4.586 6 1.422 9.164a1 1 0 101.414 1.414L6 7.414l3.163 3.164a1 1 0 101.415-1.414L7.414 6l3.164-3.164a1 1 0 00-1.414-1.414L6 4.586 2.836 1.422z","fill":"#fff"}})])
          )
        }
      }
    